<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
        <p><strong>Passo a passo:</strong></p>
        <div style="padding-left: 15px;">
          <p>1. Baixe o Modelo: Baixe o modelo disponivel para o preenchimento.</p>
          <p>2. Preencha o arquivo de acordo com as informações solicitadas.</p>
          <p>3. Faça upload de arquivos do tipo .xlsx de tamanho máximo de 100 MB.</p>
        </div>
        <v-row class="align-center">
          <v-col cols="2">
            <p><strong>Planilha Orçamentária:</strong></p>
            <sigfoco-upload-file
              :size="12"
              :maxSize="100"
              :formats="'.xlsx'"
              v-model="content.anexo"
              ref="uploadFileComponent"
              class="mt-3"
              label="Enviar arquivo"
              :resetAfterUpload="true"
              :disabled="isViewMode"
              ></sigfoco-upload-file>
          </v-col>
          <v-col cols="5"></v-col>
          <v-col cols="5" class="align-center mt-10">
            <div class="d-flex justify-end">
              <p class="my-7 mr-2"><strong>Baixar modelo:</strong></p>
              <v-btn class="ml-2 mt-4" color="primary" rounded @click="downloadModelo">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
        <v-data-table
          :key="content.orcamentos?.length"
          class="mt-5"
          dense
          :headers="headers"
          :items="content.orcamentos"
          :items-per-page="10"
          :footer-props="$footerProps"
        >
        <template v-slot:[`item.nomeArquivo`]="{ item }">
            {{ item.nomeArquivo }}
        </template>
        <template v-slot:[`item.tipo`]="{ item }">
            {{ item.tipo.toUpperCase() }}
        </template>
        <template v-slot:[`item.tamanho`]="{ item }">
            {{ item.tamanho }}
        </template>
          <template v-slot:[`item.acoes`]="{ item, index }">
            <div :key="index">
                <sigfoco-tooltip
                  :text="'Baixar'"
                  :icon="'mdi-download'"
                  :small="true"
                  @click="baixarOrcamento(item, index)"
                ></sigfoco-tooltip>
                <sigfoco-tooltip
                  :text="'Excluir'"
                  :icon="'mdi-delete'"
                  :small="true"
                  :disabled="isViewMode"
                  @click="excluirOrcamento(item, index)"
                ></sigfoco-tooltip>
            </div>
          </template>
        </v-data-table>
        <div v-if="qtdAjustes >=3 && !isViewMode" class="alert-message d-flex align-center mt-4">
          <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
          <span>Esta Solicitação de Formação já sofreu três ajustes. Não é possível realizar mais alterações.</span>
        </div>
        <v-row class="mt-3" v-if="situacaoParaExibirComentario">
          <v-col cols="12">
            <v-textarea
              v-model="content.comentario"
              label="Comentário"
              maxlength="400"
              counter="400"
              dense
              outlined
              rows="6"
              :disabled="isViewMode || qtdAjustes >= 3 || isReenviar()"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="mt-3">
          <v-col cols="12">
            <v-text-field
              v-model="content.numeroSei"
              label="Inserir Número de Processo SEI"
              maxlength="25"
              counter="25"
              dense
              outlined
              v-mask="'##########.######/####-##'"
              :rules="[(v) => validacaoSei(v)]"
              :disabled="isViewMode || !situacaoEmConsolidacao"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="!isFormador">
          <v-col cols="12">
            <p><b>{{ content.ultimaAtualizacao }}</b></p>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="d-block text-center btn-group">
        <v-col cols="12">
            <v-btn  color="primary" outlined class="ml-2" @click="voltar">
              Voltar
            </v-btn>
            <v-btn v-if="!isViewMode && !situacaoEmRevisao" color="primary" class="ml-2" @click="salvar(false)">
                Salvar
            </v-btn>
            <v-btn v-if="!isViewMode && !situacaoEmRevisao" color="primary" class="ml-2" @click="concluirFormacao()" :disabled="!podeConcluir">
                Concluir
            </v-btn>
            <v-btn v-if="!isViewMode && situacaoEmRevisao" color="primary" class="ml-2" @click="solicitarCorrecao">
              Solicitar Correção
            </v-btn>

            <v-btn v-if="!isViewMode && botaoSituacao && botaoSituacao.visivel" color="primary" class="ml-2" @click="botaoSituacao.acao()">
              {{ botaoSituacao.label }}
            </v-btn>

            <v-btn v-if="!isViewMode && !isReenviar()" color="primary" outlined class="ml-2" @click="fechar">
                Fechar
              </v-btn>
              <v-btn v-if="!isViewMode && isReenviar()" color="primary" outlined class="ml-2" @click="cancelar">
                Cancelar
              </v-btn>
              <v-btn v-if="isViewMode" color="primary" outlined class="ml-2" @click="cancelar">
                  Fechar
              </v-btn>
          </v-col>
      </v-row>
    </div>
</template>
  
  <script>
  import { Formacao } from '~/commons/classes/formacao';
  import { DialogPropsFormacao } from '~/commons/classes/dialog-props-formacao';
  import FormacaoService from "~/services/manter-formacao.service";
  import DownloadArquivoService from "~/services/download.service";
  import { globalStore }from "~/mixins/global-formacao.mixin";
  import { AUTH_NAMESPACE, USER, LOGIN } from 'store/modules/auth';
  export default {
    name: "AbaOrcamento",
    props: new DialogPropsFormacao(Formacao),
    mixins: [FormacaoService, DownloadArquivoService],
    data: () => ({
        programacaoEditandoIndex: null,
        orcamentos: [],
        jaSofreuTresAjustes: false,
        qtdAjustes: 0,
        jaSalvou: false,
        situacaoId: null,
        headers: [
        { text: "Nome do Arquivo", align: "center", value: "nomeArquivo" },
        { text: "Tipo", align: "center", value: "tipo" },
        { text: "Tamanho", align: "center", value: "tamanho" },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
        ],
        situacoesPermitidasParaConsolidar: [3, 10, 7],
        situacoesPermitidasParaAprovar: [2, 9],
      }),
    created() {
      if (globalStore.dadosOrcamento) {
          this.preencherCampos();
      }
      this.orcamentosAba = globalStore.dadosOrcamento;
      this.$nextTick(() => {
        this.isViewMode = globalStore.isViewMode;
      });
    },
    watch: {
      'content.anexo': {
        handler(novoArquivo) {
          if (novoArquivo) {
            this.adicionarArquivo(novoArquivo);
          }
        },
        deep: true,
      },
    },
    computed: {
      isViewMode() {
        return globalStore.isViewMode;
      },
      situacaoEmConsolidacao() {
        return [3].includes(globalStore.situacaoId);
      },
      situacaoEmRevisao() {
        return [2, 3, 9, 10].includes(globalStore.situacaoId);
      },
      situacaoParaExibirComentario() {
        return [2, 3, 6, 8, 9, 10].includes(globalStore.situacaoId);
      },
      user() {
        return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
      },
      podeConcluir() {
        return this.content.sucesso === true && (this.content.orcamentos?.length ?? 0) > 0;
      },
      botaoSituacao() {
        const aprovarIds    =  [2, 9];
        const consolidarIds =  [3, 10];

        if (aprovarIds.includes(this.situacaoId)) {
          return {
            label: 'Aprovar',
            acao: () => this.solicitarAprovacao(),
            visivel: true
          };
        }

        if (consolidarIds.includes(this.situacaoId)) {
          return {
            label: 'Consolidar',
            acao: () => this.solicitarConsolidacao(),
            visivel: true
          };
        }

        return null;
      }
    },
    methods: {
      // Formata um número SEI (aceita dígitos ou já formatado)
      formatarSei(sei) {
        if (!sei && sei !== 0) return null;
        const s = String(sei).trim();
        // já formatado no padrão 10.6/4-2
        const padrao = /^\d{10}\.\d{6}\/\d{4}-\d{2}$/;
        if (padrao.test(s)) return s;
        const digits = s.replace(/\D/g, '');
        if (digits.length === 22) {
          return `${digits.slice(0,10)}.${digits.slice(10,16)}/${digits.slice(16,20)}-${digits.slice(20,22)}`;
        }
        // se não tem 22 dígitos, retorna o valor original (ou null)
        return s || null;
      },

      solicitarAprovacao() {
        this.$swal({
          text: `Deseja Aprovar a Solicitação de Formação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
              return this.$solicitarAprovacao(formacaoId);
          }).then(({ data }) => {
            if (!this.content.id && data.formacaoId) {
              globalStore.setFormacaoIdCriado(data.formacaoId);
            }
            this.$notifySuccess(data.mensagem);
            this.$emit("onSave");      
            this.load();         
          }
        );
      },
      solicitarConsolidacao() {
        if(!this.content.numeroSei) {
          return this.$notifyError("Para consolidar uma formação é necessário informar o Número de Processo SEI. Por favor, preencha essa informação.");
        }
        this.$swal({
          text: `Deseja Consolidar a Solicitação de Formação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
              const numeroSei = this.content.numeroSei.replace(/[^0-9]/g, '');
              return this.$solicitarConsolidacao(formacaoId, numeroSei);
          }).then(({ data }) => {
            if (!this.content.id && data.formacaoId) {
              globalStore.setFormacaoIdCriado(data.formacaoId);
            }
            this.$notifySuccess(data.mensagem);
            this.$emit("onSave");      
            this.load();         
          }
        );
      },

      solicitarCorrecao(){
        const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
        const numeroDaAba = 3;
          if (this.qtdAjustes >= 3 && numeroDaAba === 3) {
            this.$swal({
            text: `O processo já sofreu TRÊS ajustes, portanto você não pode mais solicitar correção, deseja reprovar?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            }).then(() => {
              const payload = {
                  comentario: this.content.comentario?? null
              };
                return this.$solicitarCorrecao(formacaoId,numeroDaAba, payload);
            }).then(({ data }) => {
              if (!this.content.id && data.formacaoId) {
                    globalStore.setFormacaoIdCriado(data.formacaoId);
                }
                this.$notifySuccess(data.mensagem);
                this.$emit("onSave");      
                this.$emit('onClose');
                this.load();              
              }
            );
            return;
        }
        this.$swal({
          text: `Deseja Solicitar Ajuste da Solicitação de Formação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const payload = {
                  comentario: this.content.comentario
              };
              const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
              return this.$solicitarCorrecao(formacaoId,numeroDaAba, payload);
          }).then(({ data }) => {
            if (!this.content.id && data.formacaoId) {
                  globalStore.setFormacaoIdCriado(data.formacaoId);
              }
              this.$notifySuccess(data.mensagem);
              this.$emit("onSave");      
              this.$emit('onClose');    
              this.load();       
          }
        );
      },
      isReenviar(){
        return globalStore.isReenviarSolicitacao;
      },
      load() {
        setTimeout(() => {
        window.location.reload();
        }, 1000);
      },
      validacaoSei(v) {
        if (!v) {
          return true;
        }
        if (v.length !== 25) {
          return "SEI inválido";
        }
        return true;
      },
      fechar() {
          if(!this.jaSalvou) {
            return this.$swal({
              text: "Ao fechar sem salvar, as informações inseridas serão perdidas. Tem certeza que deseja continuar?",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Confirmar",
              cancelButtonText: "Cancelar",
          }).then((result) => { 
              if (result) {
                this.$emit('onClose');
              }
          });
        }else{
          this.$emit('onClose');
        }
        
      },
      adicionarArquivo(arquivo) {
        if (!arquivo) return;

        if (!Array.isArray(this.content.orcamentos)) {
            this.content.orcamentos = [];
        }
        const nomeArquivo = arquivo.name;
        const tipo = nomeArquivo.split('.').pop();
        const nomeDuplicado = this.content.orcamentos.some(orc => orc.nomeArquivo === nomeArquivo);
        if (nomeDuplicado) {
            this.$notifyError("Já existe um documento com esse nome. Insira um outro arquivo.");
            return;
        }
        const novoItem = {
            nomeArquivo: nomeArquivo,
            tipo: tipo,
            tamanho: arquivo.size >= 1048576 
                ? (arquivo.size / 1048576).toFixed(2) + ' MB' 
                : (arquivo.size / 1024).toFixed(2) + ' KB',
            arquivo: arquivo,
        };

        this.content.orcamentos.push(novoItem);
      },

      downloadModelo() {
        const link = document.createElement('a');
        link.href = '/img/Modelo_Repasse_Formacao.xlsx';
        link.download = 'Modelo_Planilha_Dotacao_Repasse_Formacao.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      payloadOrcamento() {
        const formData = new FormData();
        const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
        formData.append('formacaoId', formacaoId);
        const converterTamanhoParaInt = (tamanho) => {
            if (!tamanho) return 0;

            let valor = parseFloat(tamanho.replace(/ (KB|MB)$/, '').trim());
            if (tamanho.includes("MB")) {
                valor = Math.round(valor * 1024);
            } else {
                valor = Math.round(valor);
            }
            return valor;
        };
        const orcamentosInfo = this.content.orcamentos.map((orcamento) => ({
            anexoId: orcamento.anexoId,
            nomeArquivo: orcamento.nomeArquivo,
            tipo: orcamento.tipo,
            tamanho: converterTamanhoParaInt(orcamento.tamanho)

        }));
        const numeroSei = this.content.numeroSei
          ? this.content.numeroSei.replace(/[^0-9]/g, '')
          : null;
        if (numeroSei) {
          formData.append('numeroSei', numeroSei);
        }
        formData.append('comando', JSON.stringify(orcamentosInfo));
        this.content.orcamentos.forEach((orcamento) => {
            const arquivo = orcamento.arquivo;
            if (arquivo) {
                formData.append('arquivos', arquivo, orcamento.nomeArquivo);
            }
        });

        return formData;
      },

      salvar(fecharTela) {
        if (
          !this.content.orcamentos?.length
        ) {
          this.$notifyError("Por favor, anexe pelo menos UMA planilha orçamentária.");
          return;
        }
        this.$swal({
          text: `Confirma o envio da Solicitação de Formação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const formData = this.payloadOrcamento();
              const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
              return this.$cadastrarFormacaoOrcamento(formacaoId, formData);
          }).then(({ data }) => {
            if (!this.content.id && data.formacaoId) {
                  globalStore.setFormacaoIdCriado(data.formacaoId);
              }
              if (data.sucesso) {
                this.jaSalvou = true;
                this.content.anexo = null;
                this.$set(this.content, 'sucesso', true); 
              }
              this.$notifySuccess(data.mensagem);
              this.$emit("onSave");
              if (fecharTela) {
                  this.$emit('onClose');
              }                
          });  
      },
      
      concluirFormacao() {
        if (
          !this.content.orcamentos?.length
        ) {
          this.$notifyError("Por favor, anexe pelo menos UMA planilha orçamentária.");
          return;
        }
        this.$swal({
          text: `Confirma o envio da Solicitação de Formação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          }).then(() => {
              const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
              return this.$concluirFormacao(formacaoId);
          }).then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.$emit("onSave");
            this.$emit('onClose');             
            this.$router.go();
          });  
      },
      excluirOrcamento(orcamento) {
        this.$swal({
          text: `Deseja confirmar a exclusão do Orçamento?`,
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result) {
            this.content.orcamentos = this.content.orcamentos.filter(t => t !== orcamento);
            this.content.orcamentos = [...this.content.orcamentos];
            this.$forceUpdate();
            this.$notifySuccess("Orçamento removida com sucesso.");
            if (!this.content.orcamentos.length) {
              this.$set(this.content, 'sucesso', false);
            }
          }
        });
      },
      baixarOrcamento(orcamento) {
        if(!orcamento.anexoId) {
          this.$baixarArquivo(orcamento.arquivo, orcamento.nomeArquivo, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          return;
        }else {
          this.$downloadArquivos(this.$montarParamsFilters({ path: orcamento.caminho }))
          .then(({ data }) => {this.$baixarArquivo(data, orcamento.nomeArquivo, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'); 
          });                  
        }
      },
      cancelar() {
          this.$emit('onClose');
          globalStore.limpar();
      },
      voltar() {
          this.$emit('changeTab', 1);
      },
      preencherCampos() {
        if (!globalStore.dadosOrcamento) {
            return;
        }
        const dados = globalStore.dadosOrcamento;
        this.content.id = dados.id ?? null;
        this.content.orcamentos = [];
        this.orcamentos = dados.lista;
        this.content.comentario = dados.lista?.length > 0 
        ? dados.lista[0].comentario ?? "" 
        : "";
        this.content.ultimaAtualizacao = dados.lista?.[0]?.ultimaAtualizacao ?? null;
        dados.lista?.forEach(orcamentoAba => {
            let tamanho = orcamentoAba.tamanho;
            let tamanhoFormatado;

            if (tamanho >= 1048576) {
                tamanhoFormatado = (tamanho / 1048576).toFixed(2) + ' MB';
            } else {
                tamanhoFormatado = (tamanho / 1024).toFixed(2) + ' KB';
            }

            this.content.orcamentos.push({
                anexoId: orcamentoAba.anexoId,
                nomeArquivo: orcamentoAba.nome,
                caminho: orcamentoAba.caminho,
                tipo: orcamentoAba.tipo,
                tamanho: tamanhoFormatado,
            });
        });
        // Carregar número SEI quando retornado pelo DTO (aplica máscara se necessário)
        this.content.numeroSei = this.formatarSei(dados.numeroSei ?? this.content.numeroSei ?? null);
        this.$forceUpdate();
      },
      bloquearUploadSeNecessario() {
        if (this.isViewMode) {
          this.$nextTick(() => {
            if (this.$refs.uploadFileComponent) {
              this.$refs.uploadFileComponent.$el.style.pointerEvents = "none";
              this.$refs.uploadFileComponent.$el.style.opacity = "0.5";
            }
          });
        }
      }
    },

    mounted() {
      const formacaoId = this.content.formacaoId ?? globalStore.formacaoIdCriado ?? globalStore.idFormacaoAtual;
      this.$visualizarAbaOrcamento(formacaoId).then(({ data }) => {
        // Aplica máscara no número SEI retornado (se vier sem formatação)
        this.content.numeroSei = this.formatarSei(data.numeroSei ?? null);
      globalStore.dadosOrcamento = { lista: data.lista };
      this.situacaoId = data?.situacaoId ?? null;
      this.preencherCampos();
      });
      this.bloquearUploadSeNecessario();
      if(formacaoId) {
        this.$consultarStatusLimiteDeAjustes(formacaoId).then(({ data }) => {
          this.jaSofreuTresAjustes = data.jaSofreuTresAjustes;
          this.qtdAjustes = data.qtdAjustes;
        });
      }
    }
}
</script>
<style scoped>
.alert-message {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
</style>